import {
  InformationWrapper,
  Information,
  Ingredients,
  IconWrapper,
  Compliant,
} from './InformationCollapse.styles'
import Trans from 'next-translate/Trans'
import { Icon } from 'components/Icon'
import React, { useState } from 'react'
import { useTranslation } from 'hooks/useTranslation'
import { TranslationKeys } from 'locales/translationKeys'
import { TranslationQuery } from 'next-translate'

export type InformationCollapseType = {
  label: TranslationKeys
  description: TranslationKeys | string
  extraContent?: React.ReactNode
}

type InformationCollapseProps = {
  infoList: InformationCollapseType[]
  v2?: boolean
  className?: string
  transComponents?: React.ReactElement<any, string | React.JSXElementConstructor<any>>[] | Record<string, React.ReactElement<any, string | React.JSXElementConstructor<any>>> | undefined
  transValues?: TranslationQuery
}

type RotateMapType = Record<number, boolean>

export const InformationCollapse = ({
  infoList,
  v2,
  className,
  transValues,
  transComponents
}: InformationCollapseProps) => {
  const { t } = useTranslation()
  const [rotateMap, setRotateMap] = useState<RotateMapType>(() =>
    Object.fromEntries(infoList.map((_, index) => [index, false]))
  )

  const toggleRotate = (index: number) => {
    setRotateMap((prev) => ({
      ...prev,
      [index]: !prev[index],
    }))
  }

  return (
    <InformationWrapper v2={v2} className={className}>
      {infoList.map((info, index) => (
        <Information.Root v2={v2} key={index}>
          <Information.Trigger onClick={() => toggleRotate(index)}>
            {t(info.label)}
            <IconWrapper>
              {v2 ? (
                <Icon color="primary-500" size="4" name={rotateMap[index] ? 'minus' : 'plus'} />
              ) : (
                <Icon
                  className={rotateMap[index] ? 'rotate' : ''}
                  size="4"
                  name="arrow-down-line"
                  label="Expand"
                  color="accent-black"
                />
              )}
            </IconWrapper>
          </Information.Trigger>
          <Information.Content>
            <Trans
              i18nKey={info.description}
              components={{
                br: <br />,
                strong: <strong />,
                Compliant: <Compliant />,
                Ingredients: <Ingredients />,
                ...transComponents
              }}
              values={transValues}
            />
            {info.extraContent && info.extraContent}
          </Information.Content>
        </Information.Root>
      ))}
    </InformationWrapper>
  )
}
